<template>
    <div class="d-flex align-items-center justify-content-center h-100 text">No {{page}} to display</div>
</template>

<script>
    export default {
        props: ['page'],
    }
</script>

<style scoped>
    .text {
        color: #9696A8;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 700;
        line-height: 17px;
    }
</style>
